(function () {
  if (window.ScrollingBanner) return;

  const selector = '[data-scrolling-banner]';

  function init(section) {
    if (!section || section.dataset.scrollingBannerInitialized === 'true') return;

    section.dataset.scrollingBannerInitialized = 'true';
    const marquee = section.querySelector('.scrolling-banner__marquee');
    if (!marquee) return;

    const startAnimation = () => marquee.classList.add('scrolling-banner__marquee--animate');

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(startAnimation).catch(startAnimation);
    } else {
      startAnimation();
    }
  }

  function initAll(root) {
    if (root.matches && root.matches(selector)) init(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(init);
  }

  window.ScrollingBanner = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
